import React from "react";

export default function ML_AI() {
  return (
    <div>
      <h1>ML_AI</h1>
      <p>This is the ML_AI component.</p>
    </div>
  );
}
